// extracted by mini-css-extract-plugin
export default {"vertical-menu-item":"VerticalMenuItem_vertical-menu-item__P9XA4","collapsed":"VerticalMenuItem_collapsed__rz78r","icon":"VerticalMenuItem_icon__QjF7r"};